export default __webpack_public_path__ + "static/inventory-system-3-6add4f4feb805b7a8e835612108916ac.png";